module.exports = __webpack_public_path__ + "static/media/spades-jack.18c85810.png";